function _defineProperty(obj, key, value) {key = _toPropertyKey(key);if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}function _toPropertyKey(arg) {var key = _toPrimitive(arg, "string");return typeof key === "symbol" ? key : String(key);}function _toPrimitive(input, hint) {if (typeof input !== "object" || input === null) return input;var prim = input[Symbol.toPrimitive];if (prim !== undefined) {var res = prim.call(input, hint || "default");if (typeof res !== "object") return res;throw new TypeError("@@toPrimitive must return a primitive value.");}return (hint === "string" ? String : Number)(input);}var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Control } from 'react-redux-form';
import loadable from '@loadable/component';

import { Icon } from "../UI";
import { RequestParams } from "../utils/RequestParams";
import { t, I18NLink, Translate } from "../I18N";
import { SettingsHeader } from "../Settings/components/SettingsHeader";
import { LocalForm } from "../Forms/Form";
import { enable2fa as enable2faAction } from "./actions/actions";
import Auth2faAPI from "./Auth2faAPI";

const QRCodeSVG = loadable(
  async () => import( /* webpackChunkName: "qrcode.react" */'qrcode.react'),
  {
    resolveComponent: (components) => components.QRCodeSVG
  }
);












const goToAccount = (type, label) => /*#__PURE__*/
_jsx(I18NLink, { to: "/settings/account", className: `btn btn-${type}` }, void 0,
t('System', label)
);


class Configure2fa extends Component {


  constructor(props) {
    super(props);
    this.state = {
      conflict: false,
      otpauth: '',
      secret: ''
    };
    this.setSecret = this.setSecret.bind(this);
    this.enable2fa = this.enable2fa.bind(this);
  }

  async componentDidMount() {
    const { userUsing2fa } = this.props;
    if (!userUsing2fa) {
      await this.setSecret();
    }
  }

  async setSecret() {
    const { otpauth, secret } = await Auth2faAPI.setSecret(new RequestParams());
    this.setState({ otpauth, secret });
  }

  async enable2fa(values) {
    const { token } = values;
    const { enable2fa } = this.props;
    try {
      const { success } = await Auth2faAPI.enable(new RequestParams({ token }));
      if (success) {
        enable2fa();
      }
    } catch (err) {
      if (err.status === 409) {
        this.setState({ conflict: true });
      }
    }
  }

  render() {
    const { otpauth, secret, conflict } = this.state;
    const { userUsing2fa } = this.props;
    console.log('userUsing2fa', otpauth);
    return /*#__PURE__*/(
      _jsx("div", { className: "settings-content" }, void 0, /*#__PURE__*/
      _jsx("div", { className: "configure2fa-settings" }, void 0, /*#__PURE__*/
      _jsx("div", { className: "panel panel-default" }, void 0, /*#__PURE__*/
      _jsx(SettingsHeader, { backUrl: "settings/account/" }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Two-step verification")
      ), /*#__PURE__*/

      _jsx("div", { className: "panel-body" }, void 0,
      userUsing2fa && /*#__PURE__*/
      React.createElement(React.Fragment, null, /*#__PURE__*/
      _jsx("div", { className: "alert alert-success" }, void 0, /*#__PURE__*/
      _jsx(Icon, { icon: "check" }), /*#__PURE__*/
      _jsx("div", { className: "force-ltr" }, void 0, /*#__PURE__*/
      _jsx(Translate, { translationKey: "Two-step verification successfully" }, void 0,
      `Congratulations!
You have successfully configured two-step verification.`
      )
      )
      ),
      goToAccount('success', 'OK')
      ),

      !userUsing2fa && /*#__PURE__*/
      _jsx("div", {}, void 0, /*#__PURE__*/
      _jsx("p", {}, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Activate this feature for enhanced account security")
      ), /*#__PURE__*/
      _jsx("h3", {}, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Using Google Authenticator")
      ), /*#__PURE__*/
      _jsx(LocalForm, { model: "2fa", onSubmit: this.enable2fa }, void 0, /*#__PURE__*/
      _jsx("ol", {}, void 0, /*#__PURE__*/
      _jsx("li", {}, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Install the Google Authenticator app on your mobile device"

      )
      ), /*#__PURE__*/
      _jsx("li", {}, void 0, /*#__PURE__*/
      _jsx(Translate, { translationKey: "2fa add account tip" }, void 0, "Open the app and select \"Add Account\" (usually a plus symbol)"

      )
      ), /*#__PURE__*/
      _jsx("li", {}, void 0, /*#__PURE__*/
      _jsx(Translate, { translationKey: "2fa QA scan tip" }, void 0, "Scan the following QR code selecting the \"scan barcode\" option:"

      ), /*#__PURE__*/
      _jsx("div", { className: "qr-code" }, void 0,
      otpauth && /*#__PURE__*/
      _jsx(QRCodeSVG, {
        value: otpauth,
        level: "Q",
        includeMargin: false,
        size: 200,
        bgColor: "white",
        fgColor: "black" }
      )

      ), /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Or enter this secret key into your Authenticator app"), /*#__PURE__*/
      _jsx("br", {}), /*#__PURE__*/
      _jsx(Translate, { translationKey: "secret key recommendation" }, void 0, "(please keep this key secret and don't share it):"

      ), /*#__PURE__*/
      _jsx("div", { className: "secret-key" }, void 0, /*#__PURE__*/
      _jsx("span", {}, void 0, secret)
      )
      ), /*#__PURE__*/
      _jsx("li", {}, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Enter the 6-digit verification code generated by your Authenticator app:"

      ), /*#__PURE__*/
      _jsx("br", {}), /*#__PURE__*/
      _jsx("div", { className: "row" }, void 0, /*#__PURE__*/
      _jsx("div", { className: `col-8 col-md-4 col-lg-2 ${conflict ? 'has-error' : ''}` }, void 0, /*#__PURE__*/
      _jsx(Control.text, { className: "form-control", model: ".token", id: "token" })
      )
      )
      )
      ), /*#__PURE__*/
      _jsx("p", {}, void 0,
      goToAccount('default', 'Cancel'), /*#__PURE__*/
      _jsx("button", { type: "submit", className: "btn btn-success" }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Confirm")
      )
      )
      )
      )

      )
      )
      )
      ));

  }
}_defineProperty(Configure2fa, "defaultProps", void 0);

Configure2fa.defaultProps = {
  userUsing2fa: false,
  enable2fa: () => {}
};

export const mapStateToProps = (state) => ({
  userUsing2fa: state.user.toJS().using2fa
});

export const mapDispatchToProps = (dispatch) =>
bindActionCreators({ enable2fa: enable2faAction }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Configure2fa);